// 404 page
import React from "react";
import Layout from "../components/Layout";

const NotFoundPage = () => (
    <Layout>
        <div className={`center-container`} style={{ height: "100vh" }}>
            <h1 style={{ alignSelf: "end" }}>404: PAGE NOT FOUND</h1>
            <p style={{ alignSelf: "start" }}>
                You just hit a route that doesn&#39;t exist.
            </p>
        </div>
    </Layout>
);

export default NotFoundPage;
